/**
 * @file Contains customization for MuiPopover Component
 */

import { Components } from '@mui/material';

const MuiPopover: Components['MuiPopover'] = {
  styleOverrides: {
    paper: {
      border: 'var(--border-dark)',
    },
  },
};

export default MuiPopover;
